//#region [IMPORT]

import { on, removeListener, sendMessageData } from "api/prokey/prokey.websocket";
import React, { createContext, useEffect, useState } from "react"

//#endregion

const FieldPanelContext = createContext()

//-----------------------------------------------------------------
function FieldPanelProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ doctypes, setDoctypes ] = useState( [] );

  const values = {
    doctypes ,
  };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleDoctypes(data) {
      //-----------------------------------------------------------------
      setDoctypes( data );
    }

    on( 'DOCTYPES', handleDoctypes );
    sendMessageData( 'DOCTYPES_LIST_REQUEST' );

    return () => {
      removeListener( 'DOCTYPES' , handleDoctypes );
    };
  }, [] );

  //#endregion

  return (
    <FieldPanelContext.Provider value={ values }>
      {children}
    </FieldPanelContext.Provider>
  );
};

export { FieldPanelContext, FieldPanelProvider };